import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', href: '/' },
  { label: '分类大全', href: '/category' },
  { label: '排行榜', href: '/category?sort=ranking' },
  { label: '最新上架', href: '/category?sort=newest' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className={`font-heading text-xl md:text-2xl font-bold ${isScrolled ? 'text-foreground-900' : 'text-background-50'}`}>
              尾巴漫画
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 cursor-pointer ${
                  isScrolled
                    ? 'text-foreground-700 hover:text-foreground-950'
                    : 'text-background-50/80 hover:text-background-50'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-4">
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 cursor-pointer ${
                isScrolled
                  ? 'text-foreground-700 hover:text-foreground-950'
                  : 'text-background-50/80 hover:text-background-50'
              }`}
            >
              关于我们
            </Link>
            <a
              href="/category"
              className="inline-flex items-center gap-1.5 px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
            >
              开始阅读
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </a>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer ${
              isScrolled ? 'text-foreground-900' : 'text-background-50'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className="text-foreground-700 hover:text-foreground-950 text-sm font-medium py-2 whitespace-nowrap cursor-pointer"
              >
                {link.label}
              </Link>
            ))}
            <hr className="border-background-200/70" />
            <Link
              to="/about"
              className="text-foreground-700 hover:text-foreground-950 text-sm font-medium py-2 whitespace-nowrap cursor-pointer"
            >
              关于我们
            </Link>
            <a
              href="/category"
              className="inline-flex items-center justify-center gap-1.5 px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer mt-2"
            >
              开始阅读
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}